import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function OpenMiniMapIconSvg() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.84375 17.5C4.9913 17.3033 5.22285 17.1875 5.46875 17.1875H9.375C9.80648 17.1875 10.1563 17.5373 10.1563 17.9688C10.1563 18.4002 9.80648 18.75 9.375 18.75H5.85938L2.34375 23.4375H22.6563L19.1406 18.75H15.625C15.1935 18.75 14.8438 18.4002 14.8438 17.9688C14.8438 17.5373 15.1935 17.1875 15.625 17.1875H19.5313C19.7772 17.1875 20.0087 17.3033 20.1563 17.5L24.8438 23.75C25.0213 23.9867 25.0499 24.3035 24.9175 24.5681C24.7852 24.8328 24.5147 25 24.2188 25H0.781254C0.485339 25 0.214821 24.8328 0.0824833 24.5681C-0.0498542 24.3035 -0.0212949 23.9867 0.156254 23.75L4.84375 17.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 1.5625C9.91117 1.5625 7.8125 3.66117 7.8125 6.25C7.8125 8.83883 9.91117 10.9375 12.5 10.9375C15.0888 10.9375 17.1875 8.83883 17.1875 6.25C17.1875 3.66117 15.0888 1.5625 12.5 1.5625ZM6.25 6.25C6.25 2.79822 9.04822 0 12.5 0C15.9518 0 18.75 2.79822 18.75 6.25C18.75 9.4372 16.3643 12.0672 13.2813 12.4516V21.0938C13.2813 21.5252 12.9315 21.875 12.5 21.875C12.0685 21.875 11.7188 21.5252 11.7188 21.0938V12.4516C8.6357 12.0672 6.25 9.4372 6.25 6.25Z"
        fill="white"
      />
    </svg>
  )
}

export default function OpenMiniMapIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={() => OpenMiniMapIconSvg()} {...props} />
}
